export default "__VITE_ASSET__BZVa5LW2__"